
(function () {
  const STORAGE_KEY = "dt_visitor_id";

  let pageViewTracked = false;
  let productViewTracked = false;

  // Get existing visitor ID or create a new one
  function getVisitorId() {
    let visitorId = localStorage.getItem(STORAGE_KEY);

    if (!visitorId) {
      visitorId = "visitor_" + crypto.randomUUID();
      localStorage.setItem(STORAGE_KEY, visitorId);
    }

    return visitorId;
  }

  // Check analytics permission
  function isAnalyticsAllowed() {
    return window.Shopify?.customerPrivacy
      ?.analyticsProcessingAllowed() === true;
  }

  // Common event logger
  
function sendTrackingEvent(eventData) {
  // Check analytics consent
  if (!isAnalyticsAllowed()) return;

  // Prepare complete event payload
  const payload = {
    ...eventData,
    visitor_id: getVisitorId(),
    timestamp: new Date().toISOString()
  };

  // Show event in browser console
  console.log("Dash & Twine Tracking:", payload);

  // Send event to Express backend
  fetch("http://localhost:5000/api/events", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  })
    .then(async (response) => {
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Tracking API failed");
      }

      console.log(
        "Event saved in MongoDB:",
        result.data
      );
    })
    .catch((error) => {
      console.error(
        "Backend tracking failed:",
        error.message
      );
    });
}


  // Event 1: Page viewed
  function trackPageView() {
    if (pageViewTracked) return;

    sendTrackingEvent({
      event: "page_view",
      page_title: document.title,
      page_path: window.location.pathname
    });

    if (isAnalyticsAllowed()) {
      pageViewTracked = true;
    }
  }

  // Event 2: Product viewed

function trackProductViewed() {
  console.log("VIEW ITEM FUNCTION CALLED");

  if (productViewTracked) {
    console.log("View item already tracked");
    return;
  }

  const product = window.DT_PRODUCT_DATA;

  console.log("Product data detected:", product);
  console.log("Analytics allowed:", isAnalyticsAllowed());

  if (!product || !product.product_id) {
    console.log("Product data missing");
    return;
  }

  if (!isAnalyticsAllowed()) {
    console.log("Analytics consent not allowed");
    return;
  }

  sendTrackingEvent({
    event: "view_item",
    product_id: product.product_id,
    product_name: product.product_name,
    product_handle: product.product_handle,
    variant_id: product.variant_id,
    price_minor_units: product.price_minor_units,
    currency: product.currency
  });

  productViewTracked = true;

  console.log("VIEW ITEM TRACKING COMPLETED");
}


  // Event 3: Product successfully added to cart
  function trackAddToCart(item) {
    if (!item || !item.product_id) return;

    sendTrackingEvent({
      event: "add_to_cart",
      product_id: item.product_id,
      product_name: item.product_title || item.title,
      variant_id: item.id,
      variant_title: item.variant_title,
      quantity: item.quantity,
      price_minor_units: item.price,
      currency:
        window.Shopify?.currency?.active || "AED"
    });
  }

  // Check whether request is Shopify Add to Cart
  function isAddToCartRequest(url) {
    try {
      const pathname = new URL(
        url,
        window.location.origin
      ).pathname;

      return /\/cart\/add(?:\.js)?\/?$/.test(pathname);
    } catch (error) {
      return false;
    }
  }

  // Listen to Fetch requests
  function installFetchTracking() {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      const requestUrl =
        typeof args[0] === "string"
          ? args[0]
          : args[0]?.url;

      const isCartRequest = isAddToCartRequest(requestUrl);

      return originalFetch.apply(this, args).then(response => {
        if (isCartRequest && response.ok) {
          response.clone().json()
            .then(trackAddToCart)
            .catch(error => {
              console.error("Cart tracking error:", error);
            });
        }

        return response;
      });
    };
  }

  // Listen to XMLHttpRequest requests
  function installXHRTracking() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (
      method,
      url,
      ...args
    ) {
      this.__dtCartRequest = isAddToCartRequest(url);

      return originalOpen.call(this, method, url, ...args);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      if (this.__dtCartRequest) {
        this.addEventListener("load", function () {
          if (this.status >= 200 && this.status < 300) {
            try {
              const item =
                this.responseType === "json"
                  ? this.response
                  : JSON.parse(this.responseText);

              trackAddToCart(item);
            } catch (error) {
              console.error("Cart tracking error:", error);
            }
          }
        });
      }

      return originalSend.apply(this, args);
    };
  }

  // Install cart listeners
  function installCartTracking() {
    installFetchTracking();
    installXHRTracking();
  }

  // Handle visitor consent
   function handleConsent() {
    if (isAnalyticsAllowed()) {
    const visitorId = getVisitorId();

    trackPageView();
    trackProductViewed();

    // Sync visitor ID with Shopify cart
    syncVisitorIdToCart(visitorId);

  } else {
    localStorage.removeItem(STORAGE_KEY);

    console.log("Analytics tracking is not allowed.");
  }
}

  // Initialize tracking
  function initializeTracking() {
    installCartTracking();

    if (!window.Shopify?.loadFeatures) {
      console.error("Shopify privacy API loader unavailable.");
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.2"
        }
      ],
      function (error) {
        if (error) {
          console.error("Privacy API loading failed:", error);
          return;
        }

        handleConsent();

        document.addEventListener(
          "visitorConsentCollected",
          handleConsent
        );
      }
    );
  }

//   visitor identity mapping
async function syncVisitorIdToCart(visitorId) {
  if (!visitorId) return;

  try {
    // Get current cart
    const cartResponse = await fetch(
      `${window.Shopify.routes.root}cart.js`
    );

    if (!cartResponse.ok) {
      throw new Error("Unable to fetch cart");
    }

    const cart = await cartResponse.json();

    // Preserve existing cart attributes
    const attributes = {
      ...(cart.attributes || {}),
      dt_visitor_id: visitorId
    };

    // Save visitor ID in cart attributes
    const updateResponse = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ attributes })
      }
    );

    if (!updateResponse.ok) {
      throw new Error("Unable to update cart attributes");
    }

    console.log("Visitor ID synced with cart:", visitorId);

  } catch (error) {
    console.error("Cart visitor sync failed:", error);
  }
}

  initializeTracking();
})();
